"use strict";

exports.__esModule = true;
var _UpdateTicketTypeScreen = require("./UpdateTicketTypeScreen");
Object.keys(_UpdateTicketTypeScreen).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _UpdateTicketTypeScreen[key]) return;
  exports[key] = _UpdateTicketTypeScreen[key];
});